const REPLY_DRAFT_PREFIX = 'admin:conversationReply:';

const LEGACY_REPLY_DRAFT_PREFIX = 'conversation-reply-';

export const replyDraftStorageKey = (conversationId) => {
    return `${REPLY_DRAFT_PREFIX}${conversationId}`;
};

export const migrateLegacyReplyDrafts = () => {
    try {
        Object.keys(window.localStorage)
            .filter((key) => key.startsWith(LEGACY_REPLY_DRAFT_PREFIX))
            .forEach((key) => {
                const conversationId = key.slice(LEGACY_REPLY_DRAFT_PREFIX.length);
                const value = window.localStorage.getItem(key);

                window.localStorage.removeItem(key);

                if (value && value.trim() && !window.localStorage.getItem(replyDraftStorageKey(conversationId))) {
                    window.localStorage.setItem(replyDraftStorageKey(conversationId), value);
                }
            });
    } catch {
        //
    }
};
